import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {Message, MessageType} from '@vdw/angular-component-library';
import {filter, isEmpty} from 'lodash-es';

@Component({
  selector: 'app-errors-and-warnings-dialog',
  templateUrl: './errors-and-warnings-dialog.component.html',
  styleUrls: ['./errors-and-warnings-dialog.component.scss']
})
export class ErrorsAndWarningsDialogComponent implements OnInit {
  public dialogTitle: string;
  public dialogIcon: string;
  public errorMessages: Message[] = [];
  public warningMessages: Message[] = [];

  public constructor(@Inject(MAT_DIALOG_DATA) {messages}: {messages: Message[]}) {
    this.errorMessages = filter(messages, {type: MessageType.ERROR});
    this.warningMessages = filter(messages, {type: MessageType.WARNING});
  }

  public ngOnInit(): void {
    if (this.hasErrorMessages()) {
      this.dialogIcon = 'error-full-36px';
      this.dialogTitle = this.hasWarningMessages() ? 'PRODUCTION_ORDER.ERRORS.ERRORS_AND_WARNINGS' : 'PRODUCTION_ORDER.ERRORS.ERRORS';
    } else if (this.hasWarningMessages()) {
      this.dialogIcon = 'warning-full-36px';
      this.dialogTitle = 'PRODUCTION_ORDER.WEAVE_PLAN.WARNINGS.WARNINGS';
    }
  }

  public hasErrorMessages(): boolean {
    return !isEmpty(this.errorMessages);
  }

  public hasWarningMessages(): boolean {
    return !isEmpty(this.warningMessages);
  }
}
